module.exports = __webpack_public_path__ + "img/3.1d299cc0.jpg";